module.exports = __webpack_public_path__ + "img/startswith.adf4b833.png";